/* eslint-disable prettier/prettier */
import { useEffect } from "react";

// react-router components
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import HunnimePooje from "./pages/HunnimePooje";
import Donations from "./pages/Donations";
import Payment from "./pages/Payment";
import "./App.css";
import { Routes, Route, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

// Material Kit 2 React themes
import theme from "assets/theme";

// Material Kit 2 React routes
import routes from "routes";


export default function App() {
  useEffect(() => {
  document.title = "🛕Hulikere Kattemane";
}, []);

  const { pathname } = useLocation();

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} />;
      }

      return null;
    });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Navbar />
      <Routes>
        {getRoutes(routes)}

        <Route path="/" element={<Home />} />
        <Route path="/hunnime-pooje" element={<HunnimePooje />} />
        <Route path="/donations" element={<Donations />} />
        <Route path="/payments" element={<Payment/>} />
      </Routes>
    </ThemeProvider>
  );
}
